import type { SVGProps } from 'react';
const SvgTrendingFlat = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#trending_flat_svg__a)">
      <path fill="currentColor" d="m22 12-4-4v3H3v2h15v3l4-4Z" />
    </g>
    <defs>
      <clipPath id="trending_flat_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgTrendingFlat;
